// Super SA

// Make sure any image references are for images located in "public/img"

export default {
  settings: {
    disableIframePostMessage: false,
  },

  defaults: {
    age: 45,
    salary: 90000,
    salaryFrequency: 'year',
    memberType: 27,
    taxableIncome: 80000,
    spareCashflow: 9000,
    superannuationBalance: 120000,
    employerContributionRate: 12,
    employerContributionRate_2: 12,

    contributionsAfterTax: 0,
    contributionsBeforeTax: 0,
    contributionsAfterTaxFrequency: 'fortnight',
    contributionsBeforeTaxFrequency: 'fortnight',
    spareCashAmount: 0,
    spareCashAmountFrequency: 'fortnight',

    // currentVoluntaryConcessionalContributions: 200,
    // currentVoluntaryNonConcessionalContributions: 200,
    // weekly = 1, fortnightly = 1, monthly = 2, annually = 3
    // currentVoluntaryConcessionalContributionsFrequency: 3,
    // currentVoluntaryNonConcessionalContributionsFrequency: 3,

  },

  content: {
    general: {
      modellerName: "Contributions calculator",

      tabLabels: {
        welcomeTab: "Welcome",
        aboutTab: "About",
        contributionTab: "Contributions",
        calculationTab: "Your comparison",
        whatsNextTab: "Next steps",
        disclaimerAndAssumptions: "Disclaimer",
      },
    },

    welcome: {
      bannerHeading: `<h3 class="intro-h3">Welcome to the contributions calculator</h3>`,
      content: `
      <p>Thinking about making extra contributions to your super?</p>
      <p>Use this super contributions calculator to compare before-tax and after-tax contributions
      (or a mix of both) and the difference they could make on your super balance.</p>
      `,
      buttonLabel: "CONTINUE",
    },

    about: {
      bannerHeading: "First, tell us about yourself.",
      header: "",
      content: "",

      nextButtonLabel: "Next, tell us about your contributions",
      backButtonLabel: "Back",
      ageLabel: "Age",
      beforeTaxSalaryLabel: "Salary",
      salaryIsBelowContributionAmountError: `You have entered a total contribution amount that exceed your salary, please enter a higher salary amount.`,
      currentSuperBalanceLabel: "Current super balance",
      employerContributionsLabel: "Employer contributions",
      whichFundLabel: "Choose your fund",
      showWhichFundLink: false,
      whichFundLink: `#`,
      whichFundLinkText: "How do I find out?",
      whichFundTooltip: "Find everything you need to know about your fund, visit the Our Schemes page on the website.",
      whichFundWarning: "You will need to update your contributions amounts to reflect the tax treatments of your fund.",
      whichFundOptions: [
        { optionLabel: "Super SA Select", optionValue: "supersa_select", memberType: 26, taxedFund: true  },
        { optionLabel: "Triple S", optionValue: "supersa_sss", memberType: 27, taxedFund: false },

      ],
    },

    contributions: {
      bannerHeading: `Tell us about your contributions`,
      header: "",
      content: "",

      extraContributionsHeading: "Extra contributions",
      spareCashflowHeading: "Spare cashflow for additional contributions",

      extraContributionsLabel: "Are you currently making extra contributions?",
      currentContributionsLabel: "How much do you currently contribute?",
      contributionsAmountExceededSalaryError: `Your total combination of contribution amounts (pre-tax, post-tax, and spare cashflow) may have exceeded your salary level, please enter a lower contribution amount(s)`,
      afterTaxLabel: `After-tax`,
      beforeTaxLabel: `Before-tax (Salary sacrifice)`,
      spareCashflowLabel: "How much spare cashflow would you like to contribute to super?",
      contributionFrequencyLabel: "How often would you like to contribute?",

      nextButtonLabel: "Calculate my optimum contributions",
      backButtonLabel: "Back",
    },

    calculation: {
      bannerHeading: `Your comparison`,
      header: "",
      content: "",

      comparisonHeading: "Based on the information you have provided, we have calculated the most tax effective way to contribute your additional cash flow.",
      contributeText: "You need to contribute:",
      beforeTaxContributionsText: `as <strong>before-tax</strong> contributions`,
      afterTaxContributionsText: `as <strong>after-tax</strong> contributions`,
      benefitsText: "You could also receive these benefits:",
      taxSavingsText: "in tax savings",
      coContText: "Govt. co-contribution",
      lowIncomeText: "Low income super contributions",

      exceededConcessionalCap: "(You have exceeded your concessional cap)",
      notExceededConcessionalCap: "(You have not exceeded your concessional cap)",
      concessionalCapLearnMoreText: "Learn more about the concessional cap",
      concessionalCapLearnMoreLink: `https://www.supersa.sa.gov.au/superannuation/grow-your-super/salary-sacrifice/`,

      seeContributionDetailsButton: "See contribution details",
      totalAdditionalContributionBenefitHeader: `Total contributions including<br />co-contribution benefit`,
      // totalOptimisedContributionBenefitHeader: `Total optimised contribution including<br />co-contribution benefit`,
      sideBySideComparisonButton: "See side-by-side comparisons",
      superAtAgeHeader: `YOUR SUPER <br /> AT AGE`,
      withtAdditionalContributionsText: "with updated contributions",
      // withtOptimisedContributionsText: "with optimised contributions",
      comparisonAdditionalContributionsText: "updated contributions benefit",
      // comparisonOptimisedContributionsText: "optimised contributions benefit",
      withoutAdditionalContributionsText: "with current contributions",
      // withoutOptimisedContributionsText: "without optimised contributions",
      untaxedFundDetailsFootnote: "Triple S is an untaxed scheme, so contributions are not taxed, however contributions tax is shown above to account for the deferred tax liability.",
      editAssumptionsButton: "Edit assumptions",

      nextButtonLabel: "Next steps",
      backButtonLabel: "Back",
    },

    whatsnext: {
      bannerHeading: `What can I do now?`,
      header: "",
      content: `<br />
      <p class="info-text-follow-up-content">
        If you're already a member of Super SA, there are many ways you can grow your super before you retire:
      </p>
      <br />
      <div class="welcome-container">
          <div class="info-text-content">
            <div class="link-section-wrapper">
              <a
                class="section"
                href="https://www.supersa.sa.gov.au/4ae18d/globalassets/shared-content/pdfs/forms/all-schemes-forms/salary-sacrifice-for-superannuation.pdf"
                target="_blank"
                ><i class="cta-icon first"
                  ></i>
                <h4>Start salary sacrificing</h4></a
              ><a
                class="section"
                href="https://www.supersa.sa.gov.au/superannuation/grow-your-super/after-tax-contributions/"
                target="_blank"
                ><i class="cta-icon second"
                  ></i>
                <h4>Make an after tax contribution</h4></a
              >
            </div>
            <div class="link-section-wrapper">
              <a
                class="section"
                href="https://www.supersa.sa.gov.au/financial-planning/"
                target="_blank"
                ><i class="cta-icon third"
                  ></i>
                <h4>Seek financial advice</h4></a
              ><a
                class="section"
                href="https://www.supersa.sa.gov.au/superannuation/grow-your-super/"
                target="_blank"
                ><i class="cta-icon fourth"
                  ></i>
                <h4>Learn more about growing your super</h4></a
              >
            </div>
            <div class="info-text-follow-up-content">
              <div class="welcome-continue-box pt-4">
                <h3>We're here to help.</h3>
                <p>
                  To learn more about your super, <a href="https://aus01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.supersa.sa.gov.au%2Ftools-and-resources%2Fwebinars-and-seminars%2F&data=05%7C01%7CDeanna.Daminato%40sa.gov.au%7C17c2219774ba4de73d7908db663da053%7Cbda528f7fca9432fbc98bd7e90d40906%7C1%7C0%7C638216187085858161%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=5WntHekJ%2BJLdi9z52%2FpGBEW0mQkjFHh3oRMbfwEwgN8%3D&reserved=0" target="_blank"><strong>register</strong></a> for a free webinar or seminar.
                </p>
                <p>
                  If you have any specific questions, please contact our local member services team on <a href="tel:1300369315"><strong>1300 369 315</strong></a> or <a href="mailto:supersa@sa.gov.au"><strong>supersa@sa.gov.au</strong></a>.
                </p>
              </div>
            </div>
          </div>
        </div>`
      ,
    },

    disclaimer: {
      bannerHeading: `Disclaimer / Edit assumptions`,
      disclaimerTabText: "Disclaimer",
      editAssumptionsTabText: "Editable assumptions",
      content: `
      <div class="disclaimer">
        <p>The purpose of this calculator is to show which method of contributing to super (before or after tax) will likely result in the largest increase in your super for a given reduction in take-home pay.</p>
        <p>The modeller is not a recommendation and is not intended to be an exact figure. It is intended to assist you in assessing the effects your contributions and investment choices may have on your retirement outcome. The estimate may change in the future as it does not take into account any changes in the cost of living between the time of the preparation of the estimate and the future time or future changes to laws after the date of preparation of these assumptions. Do not rely on this calculator to make decisions about your retirement. You should consider your own needs, financial situation and investment objectives and may wish to get advice from a licensed financial adviser before making any financial decisions.</p>
        <p>Once you become eligible for a superannuation entitlement, your benefit entitlement will be calculated using the latest unit price in accordance with the rules of the scheme.</p>
        <p>The superannuation products administered by Super SA are exempt public sector superannuation schemes and are not regulated by the Australian Securities and Investments Commission or the Australian Prudential Regulation Authority. Super SA is not required to hold an Australian Financial Services licence to provide general advice about its superannuation products.</p>
        <p>For Triple S members, please note that your starting balance for any projection is untaxed.</p>
        <p><strong>Inflation</strong></p>
        <p>The projection allows for future wage inflation of 3.7% pa and future price inflation of 2.5% pa.</p>
        <p>Results are expressed in today's dollars by discounting with wage inflation in the accumulation phase and price inflation in the pension phase.</p>
        <p>Target income is also assumed to increase at this rate.</p>
        <p>These assumed inflation rates and the approach to discounting are consistent with ASIC Corporations (Superannuation Calculators and Retirement Estimates) Instrument 2022/603.</p>
        <p><strong>Personal income</strong></p>
        <p>The user's salary is assumed to increase in line with wage inflation.</p>
        <p>Tax calculations allow for Personal Income Tax rates, the Medicare Levy, the Low Income Tax Offset and the Senior Australian Tax Offset. It does not take into account the Medicare surcharge or any HECS/HELP debt. Threshold and Offset amounts in the first year are based on current rates. Thereafter they are indexed in line with wage inflation.</p>
        <p><strong>Employer contributions</strong></p>
        <p>The user is assumed to receive superannuation guarantee contributions. The assumed rate of contribution since 01/07/2025 is 12%.</p>
        <p><strong>Member contributions</strong></p>
        <p>Regular concessional (before tax) or non-concessional (after tax) contributions entered by the user are assumed to increase in each year in line with the user's salary. Concessional contributions are assumed to be spread evenly across the year.</p>
        <p>For the 2026-2027 financial year the general concessional cap is $32,500 for Super SA Select. Triple S does not have an annual concession cap, rather than concessional contributions being subject to an annual cap Triple S members are subject to a lifetime cap ($1.78 million &ndash; for the 2023-24 financial year) for their untaxed element in Triple S. However, if you exceed your untaxed plan cap then 47% tax (including 2% Medicare Levy) will be deducted.</p>
        <p>Concessional contributions up to the concessional contributions cap are generally taxed at 15% for Super SA Select, however Triple S is untaxed and taxed at exit. Non-concessional contributions up to the non-concessional contributions cap are not subject to tax on contribution to the superannuation environment. Where a concessional or non-concessional contribution exceeds the corresponding legislated contribution limit, the contributions are subject to additional tax levied in the personal income tax environment.</p>
        <p>Note, to the extent that the combined amount of your income and concessional contributions for a particular financial year exceeds $270,830, concessional contributions are assumed to be subject to tax at 30% for Super SA Select and 15% for Triple S to account for Division 293 tax on contribution to the superannuation environment.</p>
        <p><strong>Co-contribution</strong></p>
        <p>In each projection year, the user's eligibility for a Government co-contribution is assessed based on their salary (note, the calculator does not take into account any reportable fringe benefits that may affect your eligibility for a co-contribution) and non-concessional contributions. A co-contribution of up to $500 is made to the superannuation account if you make non-concessional contributions and your salary is below the lower income threshold and is pro-rated if your salary is between the lower income threshold and the upper income threshold.</p>
        <p>The co-contribution income thresholds are indexed in accordance with wage inflation. For the current co-contribution income thresholds, visit the Australian Tax Office (ATO) at&nbsp;<a href="http://www.ato.gov.au/rates">www.ato.gov.au/rates</a></p>
        <p><strong>Investment earnings</strong></p>
        <p>Based on the investment mix selected, the member's superannuation and pension accounts are assumed to earn anticipated investment returns of between 2.7% and 5.3% per annum before fees and tax (Note that Triple S is tax deferred, so is taxed at 15% when exiting the scheme). Past performance is not an indicator of future performance. Earnings in the superannuation account are assumed to be taxed at the relevant rate (based on the percentage of funds invested in shares, and allowing for dividend imputation and the capital gains tax concession if applicable). Earnings in the pension account are assumed to be tax-free. Investment earnings are assumed to be credited continuously to the fund.</p>
        <table>
          <tbody>
            <tr>
              <td>&nbsp;</td>
              <td>
                <p>Untaxed return</p>
              </td>
              <td>
                <p>Taxed return</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Cash</p>
              </td>
              <td>
                <p>2.70%</p>
              </td>
              <td>
                <p>2.30%</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Defensive</p>
              </td>
              <td>
                <p>3.80%</p>
              </td>
              <td>
                <p>3.40%</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Conservative/Stable</p>
              </td>
              <td>
                <p>4.40%</p>
              </td>
              <td>
                <p>4.03%</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Moderate</p>
              </td>
              <td>
                <p>4.80%</p>
              </td>
              <td>
                <p>4.49%</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Balanced</p>
              </td>
              <td>
                <p>5.00%</p>
              </td>
              <td>
                <p>4.71%</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>High Growth</p>
              </td>
              <td>
                <p>5.30%</p>
              </td>
              <td>
                <p>5.08%</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>Note: Untaxed investment return will apply for Triple S members for both accumulation and retirement phase (drawdown period). For Super SA Select members taxed return will apply during accumulation phase while untaxed return applies once they retires.</p>
        <p><strong>Better Targeted Super Concessions (division 296)</strong></p>
        <p>From 1 July 2026, Division 296 tax applies to earnings on total super balances above $3 million (15% on earnings for balances over $3 million and a further 10% on earnings for balance over $10 million). The Division 296 thresholds increase in line with price inflation, in $150,000 and $500,000 increments respectively.</p>
        <p><strong>Life expectancy</strong></p>
        <p>Life expectancies allow for future mortality improvements. They were derived based on the medium mortality rate assumptions in the Australian Bureau of Statistics in 'Population Projections, Australia, 2006 to 2101'.</p>
        <p><strong>Getting help</strong></p>
        <p>Online calculators let you explore your potential retirement income in more detail. They let you personalise the estimate, and show you how you can improve your retirement income. Don&rsquo;t make any changes to your retirement savings arrangements based on this estimate. Before you make changes, you should get further information or advice.</p>
      </div>`,

      editAssumptionsHeading: "Edit assumptions",
      retirementAgeLabel: "Retirement age",
      wageInflationLabel: "Wage inflation",
      wageInflationDescription: "The wage inflation slider represents changes to the Average Weekly Ordinary Time Earnings (AWOTE) rather than your personal salary expectation. It is used to discount future amounts into current values.",
      priceInflationLabel: "Price inflation",
      insurancePremiumLabel: "Insurance premium",
      userDefinedInvestmentOptionLabel: "User defined investment option",
      createUserDefinedInvestmentOptionLabel: "Create a user defined option based on",
      grossReturnLabel: "Gross Return",
      feePercentageOnBalanceLabel: "Fee Percentage On Balance",
      feePercentageOnBalanceCappedLabel: "Fee Percentage On Balance Capped",
      feePercentageOnBalanceCappedCapLabel: "Fee Percentage On Balance Capped Cap",
      feePercentageOnContributionsLabel: "Fee Percentage On Contributions",
      feeAnnualDollarLabel: "Fee Annual Dollar",
      backButtonLabel: "Back",
    },
  },

  params: {
    DefaultInvestmentOption: 5,
    DefaultInvestmentOptionInRetirement: 5,

    frequency: {
      year: 1,
      month: 1 / 12,
      fortnight: 12 / 313,
      week: 6 / 313,
      default: 1,
    },

    ageNow: {
      min: 15,
      max: 74,
    },
    salary: {
      min: 1000,
      max: 500000,
    },
    superannuationBalance: {
      min: 0,
      max: 3000000,
    },
    employerContributionRate: {
      min: 0,
      max: 20,
    },
    contributionsBeforeTax: {
      min: 0,
      max: 32500,
    },
    contributionsAfterTax: {
      min: 0,
      max: 130000,
    },
    spareCashAmount: {
      min: 0,
      max: 100000,
    },

    spareCashflowLimiterTaxedFund: 0.5,
    spareCashflowLimiterUntaxedFund: 0.5,

    retirementAge: {
      min: 55,
      max: 74,
    },

    priceInflation: {
      min: 0,
      max: 10,
    },
    wageInflation: {
      min: 0,
      max: 10,
    },
    insurancePremium: {
      min: 0,
      max: 500,
    },
    feePercentageOnBalance: {
      min: 0,
      max: 3,
    },
    feePercentageOnBalanceCapped: {
      min: 0,
      max: 3,
    },
    feePercentageOnBalanceCappedCap: {
      min: 0,
      max: 5000,
    },
    feePercentageOnContributions: {
      min: 0,
      max: 3,
    },
    feeAnnualDollar: {
      min: 0,
      max: 500,
    },

    minAge: 16,
    maxAge: 64,
    minSalary: 0,
    maxSalary: 584000,
    salaryStep: 2000,
    minSuperannuationBalance:0,
    maxSuperannuationBalance:2000000,
    minEmployerContributionsRate: 0,
    maxEmployerContributionsRate: 30
  },


  analytics: {
    gacode: "G-DNC8H2Q50N"
  },

  lastUpdated: "1 July 2026"
};